import { render, staticRenderFns } from "./ArticleHeadlinesSection.vue?vue&type=template&id=64ba6bcb&scoped=true&"
import script from "./ArticleHeadlinesSection.vue?vue&type=script&lang=ts&"
export * from "./ArticleHeadlinesSection.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleHeadlinesSection.vue?vue&type=style&index=0&id=64ba6bcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba6bcb",
  null
  
)

export default component.exports